module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/cards/cards-style5/cards-style5.component.scss
// module id = ./src/app/features/cards/cards-style5/cards-style5.component.scss
// module chunks = main